import * as Factory from 'factory.ts'
import faker from 'faker'

import { PrimaryCategoryApiModelStub } from '@webapp/core/data-access/api-models/stubs/PrimaryCategoryApiModel.stub'
import { type LegacyBudgetApiModel } from '../LegacyBudgetApiModel'

export const LegacyBudgetApiModelStub =
  Factory.Sync.makeFactory<LegacyBudgetApiModel>({
    account: Factory.each(() => ({
      account_code: {
        id: faker.random.number(),
        code: faker.random.number().toString(),
        description: faker.random.word(),
      },
      id: faker.random.number(),
    })),
    approved: Factory.each(() => faker.random.number().toString()),
    budget: Factory.each(() => faker.random.number().toString()),
    department: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.random.word(),
      location: PrimaryCategoryApiModelStub.build(),
    })),
    endDate: Factory.each(() => faker.date.future().toISOString()),
    id: Factory.each(() => faker.random.number()),
    invoiced: Factory.each(() => faker.random.number().toString()),
    is_closed: false,
    is_expired: false,
    pending: Factory.each(() => faker.random.number().toString()),
    purchased: Factory.each(() => faker.random.number().toString()),
    startDate: Factory.each(() => faker.date.past().toISOString()),
  })
